// 英语
// import enLocale from 'element-ui/lib/locale/lang/en.js'
// import {deepObjectMerge} from '../../utils/index.js'
const lang = {
  login: {
    user: 'Username',
    account: 'Account',
    password: 'password',
    signin: 'Sign in',
    signtitle: 'User login',
    forgetpassword: 'Forgot password',
    regsiter: 'Developer register',
    accountLogin: 'Log in with your account',
    wechartLogin: 'Log in with your wechart',
    codeTips:
      'Check code SMS has been sent, valid for 30 minutes, please check in time.'
  },
  common: {
    retrieveAfterSeconds: 'seconds',
    getVerificationCode: 'Get  code',
    uploadCompanyLogo: 'Support JPG, PNG upload avatar image format!',
    uploadCompanyLogoSize: 'Upload avatar image size can not exceed 2MB!',
    uploadAvaterTips:
      'Avatar supports JPG, PNG format, and the size does not exceed 2M',
    uploadSuccess: 'upload success',
    uploadFail: 'upload fail',
    i18nKey: 'i18nKey',
    sys: 'XiaMen ZKTeco CDP front-end framework',
    add: 'Add',
    search: 'Search',
    edit: 'Editor',
    release: 'Release',
    update: 'Update',
    delete: 'Delete',
    selectDate: 'Select date',
    select: 'Please select',
    cancel: 'Cancel',
    confirm: 'Confirm',
    success: 'Success',
    fail: 'Failed',
    remark: 'Remark',
    name: 'Name',
    status: 'Status',
    statusRequire: 'Please select the status',
    remarkRequire: 'Please enter the remark',
    nameRequire: 'Please enter the name',
    confirmDelete: 'Confirm delete?',
    successDelete: 'Successfully delete',
    cancelDelete: 'Deletion has been cancelled',
    addUser: 'Add user', //
    addSuccess: 'Add success',
    inputUserName: 'Please enter the user name',
    sourceList: 'Source list',
    targetList: 'Target list',
    addUserSuccess: 'Add user successfully.',
    selectUser: 'Please select the user before you operate',
    confirmDeleteUserTip: 'Are you sure to delete the selected user?',
    startTime: 'Start time',
    startTimePla: 'Please enter the start time',
    endTime: 'End Time',
    endTimePla: 'Please enter the end time',
    userNamePla: 'Please enter the user name',
    logNamePla: 'Please enter the log name',
    logType: 'Log type',
    select1record: 'Please click the form to select the record!',
    confirmDeleteRecordTip: 'Are you sure to delete the selected record?',
    operation: 'Operation',
    errorNotice: 'Error',
    warningNotice: 'Warm prompt'
  },
  user: {
    accountByLogin: 'Login account',
    dbsPrivacy: '《Smart DBS Privacy Policy》',
    agree: 'I agree',
    useEmailReg: 'Use email to register',
    usePhoneReg: 'Use  phone to register',
    pwdStrength: 'Password strength',
    week: 'Week',
    middle: 'Middle',
    hight: 'Hight',
    noConfirmedPwd: 'Make sure the password cannot be empty',
    emailCodeError:
      'The email verification code entered is incorrect, please try again',
    sureEmailTip: 'Please enter the correct email address',
    onceLogin: 'Login immediately',
    baseInfo: 'Basic',
    activation: 'Get code',
    userNameTips:
      'Please fill in the user name not registered by entropy-based technology equipment platform',
    emailTips:
      'Please fill in the email address not registered by  device data bridge platform',
    emailCode: 'Email code',
    inputEmailCode: 'Please enter the email verification code',
    emailCodeTips:
      'Click to get the verification code and you will receive the verification email. Please backfill the 6-bit verification code in the email',
    inputPwdTips:
      'The password must contain numbers and letters and be between 8 and 16 digits long',
    services: 'Third party developer service agreement',
    regsiter: 'Register',
    hasAcount: 'Existing developer account?',
    startTime: 'Register start time',
    endTime: 'Register end time',
    superAdmin: 'Super admin',
    account: 'Account',
    status: 'Status',
    userName: 'User name',
    password: 'Password',
    confirmedPwd: 'Confirmed password',
    email: 'Email',
    phone: 'Phone',
    sex: 'Sex',
    nickName: 'Nickname',
    department: 'Department',
    role: 'Role',
    roleManagement: 'Role management',
    registerTime: 'Register time',
    inputAccount: 'Please enter account/phone/email',
    inputForgetName: 'Please enter account',
    inputName: 'Please enter name',
    inputPwd: 'Please set the password',
    inputPwd2: 'Please enter the password',
    input2ndPwd: 'Please enter the password again',
    pwdInconsistent: 'The password entered for the two times is inconsistent.',
    inputEmail: 'Please enter email',
    inputPhone: 'Please enter phone',
    inputNickName: 'Please enter nickname',
    selectStatus: 'Please select status',
    addUser: 'Add user',
    modifyUser: 'Update user',
    userDetail: 'User detail',
    select1record: 'Please click on the form to select a record',
    notAllowToChange: 'Super administrator not allowed to change!',
    notAllowToRemove: 'Super administrator is not allowed to delete!',
    notAllowToResetPwd: 'Reset super administrator password is not allowed!',
    notAllowToFreeze: 'Super administrator is not allowed to freeze',
    confirmDeleteTip:
      'Are you sure you want to delete a user which account is | ?',
    confirmResetPwd: 'Reset Password',
    confirmResetPwdTip:
      "Are you sure you want to will account for:  |  's password reset to 12345678?",
    successResetPwd: 'Reset password successfully',
    cancelResetPwd: 'Reset password has been cancelled',
    confirmFreeze: 'Freeze user',
    deleteUser: 'Delete user',
    confirmFreezeTip:
      'Are you sure you want to freeze the user which account is |?',
    successFreeze: 'Freeze user successfully',
    cancelFreeze: 'Freeze User has been cancelled',
    notNeedUnfreeze: 'The current user is enabled that no need to unfreeze',
    confirmUnfreeze: 'Unfreeze user',
    confirmUnfreezeTip:
      'Are you sure you want to unfreeze the user which account is |?',
    successUnfreeze: 'Unfreeze user successfully',
    cancelUnfreeze: 'Unfreeze User has been cancelled',
    roleAllot: 'Allot role'
  },
  department: {
    addDept: 'Add department',
    updateDept: 'Update department',
    parentDept: 'Parent',
    deptName: 'Name',
    deptStatus: 'Status',
    notDeleteRoot: 'Root department is not allowed to delete!',
    notDeleteDept: 'This department contains sub-departments, cannot delete!',
    confirmDeleteDeptTip: 'Are you sure to delete this department?',
    selectDept: 'Please select the department before you operate'
  },
  area: {
    addArea: 'Add area',
    updateArea: 'Update area',
    parentArea: 'Parent',
    areaName: 'Name',
    areaStatus: 'Status',
    notDeleteRoot: 'Root area is not allowed to delete!',
    notDeleteArea: 'This area contains sub-areas, cannot delete!',
    confirmDeleteAreaTip: 'Are you sure to delete this area?',
    selectArea: 'Please select the area before you operate.'
  },
  resource: {
    resourceName: 'Resource name',
    sortNo: 'Sort',
    resourceEvent: 'Button event',
    resourceType: 'Type',
    notDeleteRoot: 'Root resource are not allowed to be deleted!',
    notUpdateRoot: 'Root resource are not allowed to be modified!',
    addResource: 'Add resource',
    updateResource: 'Update resource',
    confirmDeleteTip: 'Are you sure you want to delete the resource: ',
    icon: 'Icon',
    routerName: 'Routing name',
    btnGroup: 'Group name',
    urlRequire: 'Please enter the url',
    routerNameRule: 'The same name as the development configuration routing',
    btnGroupRequire: 'Please enter the name of the button group',
    btnTypeRequire: 'Please select the button type',
    btnStyleRequire: 'Please select the button style',
    btnType: 'Button type',
    btnStyle: 'Button style',
    btnEffect: 'Button effect',
    parentResource: 'Parent',
    default: 'Default',
    primary: 'Primary',
    success: 'Success',
    text: 'Text',
    info: 'Information',
    warning: 'Warning',
    danger: 'Dangerous',
    plain: 'Plain',
    round: 'Round',
    circle: 'Circle',
    typeRequire: 'Please select the resource type',
    sortNoRequire: 'Please enter the serial number',
    intRequire: 'Please enter a positive integer',
    parentRequire: 'Please select the parent resource',
    parentRule1: 'Parent resource is not allowed to be resource itself',
    parentRule2:
      'Parent resource is not allowed to be children of this resource',
    resourceEventRequire: 'Please enter the button event',
    disabled: 'Disabled'
  },
  role: {
    addRole: 'Add role',
    addRoleGroup: 'Add role group',
    role: 'Role',
    addRoleSuccess: 'Add role success',
    updateRoleSuccess: 'Update role success',
    roleGroup: 'Role group',
    roleName: 'Role name',
    roleGroupName: 'Role group name',
    roleGroupNameRequire: 'Please enter the role group name',
    roleGroupRequire: 'Select the role group',
    roleNameRequire: 'Please enter the role name',
    noGroup: 'No group',
    confirmDeleteTip: 'Are you sure you want to delete this user role?',
    confirmDeleteGroupTip:
      'Are you sure you want to delete this user role group?',
    addUser: 'Add user',
    authorization: 'Authorization',
    authorizeSuccess: 'Authorization success',
    authorizeFail: 'Authorization failure',
    selectRoleToAddUserTip:
      'Select the role you want to add users to on the left.',
    selectRoleToAuthorizeTip:
      'Please select the role you want to authorize on the left.',
    selectUser: 'Please select the user',
    confirmDeleteUserTip: "Are you sure you want to remove： |'s user role?",
    notDeleteAdmin:
      'The admin user under the super administrator is not allowed to delete!'
  },
  param: {
    paramType: 'Parameter type',
    paramName: 'Parameter name',
    paramValue: 'Parameter value',
    sortNo: 'Order value',
    paramStatus: 'Parameter status',
    addParam: 'Add parameter',
    updateParam: 'Update parameter',
    confirmDeleteTip: 'Are you sure to delete this parameter?',
    typeRequire: 'Please enter the parameter type',
    nameRequire: 'Please enter the parameter name',
    valueRequire: 'Please enter the parameter value'
  },
  dictionary: {
    name: 'Name',
    type: 'Type',
    dictName: 'Name',
    dictType: 'Type',
    value: 'Value',
    sortNo: 'Order value',
    addDict: 'Add dictionary',
    updateDict: 'Update dictionary',
    confirmDeleteTip: 'Are you sure to delete this dictionary?',
    nameRequire: 'Please enter the dictionary name.',
    typeRequire: 'Please enter the dictionary type.',
    valueRequire: 'Please enter the dictionary value.',
    sortNoRequire: 'Please enter the order value.'
  },
  announcement: {
    id: 'Id',
    title: 'Title',
    content: 'Content',
    validDate: 'Valid date',
    modifiedDate: 'Modified date',
    modifiedBy: 'Modified by',
    createdDate: 'Release time',
    createdBy: 'Created by',
    addDict: 'Add announcement',
    updateDict: 'Update announcement',
    beginTime: 'Begin',
    endTime: 'End',
    effectTime: 'Begin',
    expirationTime: 'End',
    addAnnouncement: 'Add announcemnet',
    deleteSure: 'Are you sure you want to delete this notice?',
    modifyAnnouncemnet: 'Modify announcemnet',
    choiceTime: 'Choose time',
    announcementStatus: 'Whether issued',
    inputTitle: 'Please enter the title',
    inputContent: 'Please enter the content',
    inputTime: 'Please enter the time',
    titleMaxLength: 'The maximum length is 50',
    contentMaxLength: 'The maximum length is 500',
    nameMaxLength: 'The maximum length is 30',
    announcementDetal: 'Announcement detail',
    status: 'Status',
    annRelease: 'Published',
    annNotRelease: 'Not release',
    releaseSuccess: 'Release success',
    releaseFail: 'Post failure'
  },
  advice: {
    id: 'Id',
    advice: 'Advice',
    reply: 'Reply',
    replyBy: 'Reply by',
    replyDate: 'Reply time',
    status: 'Status',
    createdDate: 'Create time',
    createdBy: 'Created by',
    createTime: 'Create time',
    beginTime: 'Begin time',
    endTime: 'End time',
    replayStatus: 'Replay status',
    replied: 'Replied',
    noReply: 'No reply',
    all: 'All',
    replayBtn: 'Replay',
    deleteBtn: 'Delete',
    addAdvice: 'Feedback',
    adviceContent: 'Content',
    adviceReplay: 'Advice replay',
    advContent: 'Advice',
    replayContent: 'Replay',
    deleteSure: 'Are you sure to delete this recommendation?'
  },
  loginLog: {
    loginLog: 'Login log',
    loginFailLog: 'Login failure log',
    exitLog: 'Exit log',
    account: 'Account',
    time: 'Time',
    details: 'Details'
  },
  operatorLog: {
    logName: 'Log name',
    operatorLog: 'Operation log',
    exceptionLog: 'Exception log',
    account: 'Account',
    className: 'Operation class',
    methodName: 'Method',
    msg: 'Message',
    result: 'Result',
    costTime: 'Time-consuming(ms)',
    time: 'Time'
  },
  account: {
    accountInfo: 'Account information',
    modifyPwd: 'Modify password',
    loginOut: 'Logged out',
    account: 'Account',
    oldPwd: 'Old password',
    newPwd: 'New password',
    confirmNewPwd: 'Confirm password',
    oldPwdRequire: 'Please enter the old password',
    newPwdRequire: 'Please enter the new password',
    confirmNewPwdRequire: 'Please enter the new password again',
    newEqualOld: 'The new password is the same as the old one',
    newNotEqualNew: 'The two password entries are different',
    modifyPwdSuccess: 'Modify password successfully',
    newPasswordLength: 'The length must be between 8 and 16 bits',
    mustContain: 'Must contain numbers and letters'
  },
  dstConfig: {
    colHeaderTip: 'If the ending year is N/A, it is permanent',
    dstName: 'DST name',
    timezone: 'timeZone',
    startTime: 'startTime',
    endTime: 'endTime',
    startYear: 'startYear',
    endYear: 'endYear',
    dstNameRequire: 'Please enter the DST name',
    timezoneRequire: 'Please enter the timezone',
    startTimeRequire: 'Please enter the startTime',
    endTimeRequire: 'Please enter the endTime',
    startYearRequire: 'Please enter the startYear',
    endYearRequire: 'Please enter the endYear',
    active: 'active',
    addDstConfig: 'add DST config',
    updateDstConfig: 'update DST config',
    confirmDeleteTip: 'Are you sure delete this daylight saving time rule?',
    startTimeDesc:
      'The format is: MMIIWWHH, MM: month, II: the first few weeks (01: indicates the first week, 02: indicates the second week, 03: indicates the third week, 04: indicates the fourth week, 11: Means the first week to the end), WW: week, HH: hour',
    endTimeDesc: 'If it is empty, it is permanently valid'
  }
}
export default lang // deepObjectMerge(, enLocale)



// WEBPACK FOOTER //
// ./src/cdpBase/i18n/lang/en.js